
const NoDataMessage = ({ text, icon, color }: any) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center h-100 py-5">
      {icon ? <span className="svg-60 d-inline-block mb-4">{icon}</span> : ""}
      <p className={`fs-6 fw-semibold ${color ? color : "text-black"} mb-0`}>
        {text ?? ""}
      </p>
    </div>
  );
};

export default NoDataMessage;